import { render, staticRenderFns } from "./issueChangeLogModal.vue?vue&type=template&id=496f2250&scoped=true&"
import script from "./issueChangeLogModal.vue?vue&type=script&lang=ts&"
export * from "./issueChangeLogModal.vue?vue&type=script&lang=ts&"
import style0 from "./issueChangeLogModal.vue?vue&type=style&index=0&id=496f2250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f2250",
  null
  
)

export default component.exports